import { createSlice } from '@reduxjs/toolkit';
import { searchGooglePlaces } from '../dao/ArticleDAO';
import { showErrorMessage } from '@/shared/adapters/toast';

const initialState = {
  searchResults: [],
  isSearching: false,
  error: null
};

const googlePlacesSlice = createSlice({
  name: 'googlePlaces',
  initialState,
  reducers: {
    searchStart: (state) => {
      state.isSearching = true;
      state.error = null;
    },
    searchSuccess: (state, action) => {
      state.searchResults = action.payload;
      state.isSearching = false;
    },
    searchFailure: (state, action) => {
      state.error = action.payload;
      state.isSearching = false;
      state.searchResults = [];
    },
    clearResults: (state) => {
      state.searchResults = [];
    }
  }
});

export const {
  searchStart,
  searchSuccess,
  searchFailure,
  clearResults
} = googlePlacesSlice.actions;

export const performGooglePlacesSearch = (query) => async (dispatch) => {
  if (!query) {
    showErrorMessage('Please enter a search query');
    return;
  }

  dispatch(searchStart());

  try {
    const results = await searchGooglePlaces(query);

    if (results.results?.length > 0) {
      dispatch(searchSuccess(results.results));
    } else {
      dispatch(searchFailure('No results found'));
      showErrorMessage(`No results found for "${query}". Try a different search.`);
    }
  } catch (error) {
    dispatch(searchFailure(error.message));
    showErrorMessage(`Failed to search Google Places: ${error.message}`);
  }
};

export const selectGooglePlacesResults = (state) => state.googlePlaces.searchResults;
export const selectGooglePlacesIsSearching = (state) => state.googlePlaces.isSearching;
export default googlePlacesSlice.reducer;
